import { render } from "./RedirectModal.vue?vue&type=template&id=13fcbf09"
import script from "./RedirectModal.vue?vue&type=script&lang=js"
export * from "./RedirectModal.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__